import { atom } from 'recoil';

export const voicePersona = atom({
  key: 'voicePersonaState',
  default: {
    DisplayName: 'Ava (Dragon HD)',
    AzureCode: 'en-US-Ava:DragonHDLatestNeural',
  },
});
